// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactModule-module_wrapper__qFNfi","label":"ContactModule-module_label__IHFlG","dropdown":"ContactModule-module_dropdown__RZJax"};